var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement(
  "svg",
  _extends({ width: "30", height: "30", viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
  React.createElement(
    "defs",
    null,
    React.createElement("path", { d: "M8.309 14.983l-4.285 2.224a.75.75 0 0 1-1.084-.794l.947-5.455-4.006-3.855A.75.75 0 0 1 .295 5.82l5.545-.795L8.33.046a.75.75 0 0 1 1.34 0l2.49 4.979 5.545.795a.75.75 0 0 1 .413 1.283l-4.006 3.855.948 5.455a.75.75 0 0 1-1.084.794L9.69 14.983a1.5 1.5 0 0 0-1.382 0z", id: "navbar-likes" })
  ),
  React.createElement("use", { fill: "#F8C637", xlinkHref: "#navbar-likes", transform: "translate(6 6)", fillRule: "evenodd" })
));


// WEBPACK FOOTER //
// ./src/shared/components/svgs/Likes.svg